export function useCampaigns() {
    const getCampaignById = (id: number) => runtimeStore.campaigns.find(campaign => campaign.campaignId === id)
    const getCampaignNameById = (id: number) => getCampaignById(id)?.name || id

    const campaigns = computed(() => runtimeStore.campaigns)

    return {campaigns, getCampaignNameById}
}
